import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
// lodash
import get from 'lodash/get';
// redux
import { connect } from 'react-redux';
// classnames
import classNames from 'classnames';
// components
import OrderSummary from '../order-summary/OrderSummary';
import OrderTotals from '../order-totals/OrderTotals';
// constants
import deliveryConstants from '../../constants/deliveryConstants';
// styles
import styles from './sidebar.scss';
import { isFeatureActive } from '../../redux/reducers/config/configReducer';
import featureConstants from '../../constants/featureConstants';

export class Sidebar extends PureComponent {

  static propTypes = {
    amounts: PropTypes.shape({}),
    isClickCollectOrder: PropTypes.bool,
    isDeliveryPage: PropTypes.bool,
    isGiftReceiptOrder: PropTypes.bool,
    items: PropTypes.arrayOf(PropTypes.object),
    partnerDiscountEnabled: PropTypes.bool,
    promotionalCode: PropTypes.shape({}),
    streamlinedPayments: PropTypes.bool,
  };

  static defaultProps = {
    amounts: {},
    isClickCollectOrder: false,
    isDeliveryPage: false,
    isGiftReceiptOrder: false,
    items: undefined,
    partnerDiscountEnabled: false,
    promotionalCode: {},
    streamlinedPayments: false,
  };

  render() {
    const {
      amounts,
      isClickCollectOrder,
      isDeliveryPage,
      isGiftReceiptOrder,
      items,
      partnerDiscountEnabled,
      promotionalCode,
      streamlinedPayments,
    } = this.props;

    const containerClassnames = classNames(styles.container, {
      [styles.sticky]: streamlinedPayments,
    });

    return (
      <div
        className={containerClassnames}
        data-test="sidebar-container"
      >
        <div className={styles.innerContainer}>
          <OrderSummary
            items={items}
            partnerDiscountEnabled={partnerDiscountEnabled}
            sidebarView
          />

          <OrderTotals
            amounts={amounts}
            deliveryCharge={get(amounts, 'deliveryCharge')}
            isClickCollectOrder={isClickCollectOrder}
            isDeliveryPage={isDeliveryPage}
            isGiftReceiptOrder={isGiftReceiptOrder}
            partnerDiscountEnabled={partnerDiscountEnabled}
            promotionalCode={promotionalCode}
            sidebarView
          />
        </div>
      </div>
    );
  }
}

export function mapStateToProps(state) {
  return {
    amounts: state.orderForm.amounts,
    isClickCollectOrder: state.delivery.selectedDeliveryChoiceId === deliveryConstants.CLICK_AND_COLLECT,
    isGiftReceiptOrder: state.orderForm.isGiftReceiptOrder,
    items: state.orderForm.items,
    partnerDiscountEnabled: state.user.partnerDiscountEnabled,
    promotionalCode: get(state.orderForm, 'promoCodeApplied'),
    streamlinedPayments: isFeatureActive(state, featureConstants.STREAMLINED_PAYMENTS),
  };
}

export default connect(state => mapStateToProps(state))(Sidebar);
